import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { RateService } from '../../../services/rate.service';
import { UtilitiesService } from '../../../services/utilities.service';
import { TableService } from '../../../services/table.service';
import { DataTransferService } from '../../../services/DataTransferService';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-rate-calculator',
    templateUrl: './rate-calculator.component.html',
    styleUrls: ['./rate-calculator.component.scss']
})
export class RateCalculatorComponent implements OnInit {
    calculateRateRequest: ICalculateRate = {} as any;
    countries = [];
    branchWeightUnit;
    branchCompanyCountryName;
    branchCompanyCountryCode;
    currentUserId: any;
    userAccounts: any[];
    selectedAccount: any;
    productTypes: any[];
    uiFromCountryCode: any;
    constructor(private rateService: RateService, private utilities: UtilitiesService, private userContext: TableService, private data: DataTransferService, private router: Router,private translate: TranslateService) {
        JSON.stringify(this.calculateRateRequest);
        this.branchWeightUnit = JSON.parse(sessionStorage.getItem("company")).BranchCompanyDefaultWeightUnit;
        this.branchCompanyCountryCode = JSON.parse(sessionStorage.getItem("company")).BranchCompanyCountryCode;
        this.branchCompanyCountryName = JSON.parse(sessionStorage.getItem("company")).BranchCompanyCountryName;
    }

    validatorObj = {
        account: {
            valid: false,
            message: ''
        },
        destination: {
            valid: false,
            message: ''
        },
        weight: {
            valid: false,
            message: ''
        }
    }

    checkValidation() {
        var inValidDestination = this.calculateRateRequest.ToCountryCode == "" || this.calculateRateRequest.ToCountryCode == null;
        var inValidWeight = this.calculateRateRequest.Weight.Value == 0 || this.calculateRateRequest.Weight == null;
        var inValidAccount = this.calculateRateRequest.Account.Number == "";

        if (inValidDestination || inValidWeight || inValidAccount) {
            if (inValidDestination) {
                this.validatorObj.destination.valid = false;
                this.validatorObj.destination.message = `<i class="armx-icon armx-cancel">${this.translate.instant('pages.rateCalculatorPage.validDestination')}</i>`;
            }
            else {
                this.validatorObj.destination.valid = true;
                this.validatorObj.destination.message = '';
            }
            if (inValidWeight) {
                this.validatorObj.weight.valid = false;
                this.validatorObj.weight.message = `<i class="armx-icon armx-cancel">${this.translate.instant('pages.rateCalculatorPage.validWeight')}</i>`;
            }
            else {
                this.validatorObj.weight.valid = true;
                this.validatorObj.weight.message = '';
            }
            if (inValidAccount) {
                this.validatorObj.account.valid = false;
                this.validatorObj.account.message = `<i class="armx-icon armx-cancel">${this.translate.instant('pages.rateCalculatorPage.accountConfirmation')} </i>`;
            }
            else {
                this.validatorObj.account.valid = true;
                this.validatorObj.account.message = '';
            }
            return false;
        }
        else {
            this.validatorObj.destination.valid = true;
            this.validatorObj.destination.message = '';
            this.validatorObj.weight.valid = true;
            this.validatorObj.weight.message = '';
            this.validatorObj.account.valid = true;
            this.validatorObj.account.message = '';
            return true;
        }
    }

    calculateRate() {
        if (this.checkValidation()) {
            this.rateService.calculateRate(this.calculateRateRequest,
                (res) => {
                    this.productTypes = res.filter(x => x.RateDetails != null);
                    //this.productTypes = res.filter(x => x.RateDetails != null && x.RateDetails.TotalAmount > 0);
                }, (erro) => {
                });
        }
    }

    selectAccount(account) {
        if (account[0].Number != undefined) {
            this.calculateRateRequest.Account.Reference = account[0].Reference;
            this.calculateRateRequest.Account.Number = account[0].Number;
            this.calculateRateRequest.Account.Name = account[0].Name;
        }
        else {
            var selectedAccount = this.userAccounts.filter(x => { return x.Number == account });
            this.calculateRateRequest.Account.Reference = selectedAccount[0].Reference;
            this.calculateRateRequest.Account.Number = selectedAccount[0].Number;
            this.calculateRateRequest.Account.Name = selectedAccount[0].Name;
        }
    }

  onDestinationSelect(distination) {
        if (distination) {
            this.country = distination;
            this.calculateRateRequest.ToCountryCode = distination.value;
            this.validatorObj.destination.valid = true;
            this.validatorObj.destination.message = '';
        }
        else {
            this.calculateRateRequest.ToCountryCode = "";
            this.validatorObj.destination.valid = false;
            this.validatorObj.destination.message = `<i class="armx-icon armx-cancel">${this.translate.instant('pages.rateCalculatorPage.validCountryCode')}</i>`;
        }
    }

    onCountrySelect(country) {
        this.calculateRateRequest.FromCountryCode = country.value;
        this.uiFromCountryCode = country.key;
    }

    selectProductGroup() {
        if (this.calculateRateRequest.FromCountryCode == this.calculateRateRequest.ToCountryCode) {
            return "DOM"
        }
        else {
            return "EXP"
        }
    }

    getUserAccounts() {
      this.currentUserId = JSON.parse(sessionStorage.getItem("company")).UserLocationId;
        this.userContext.getRow("GET_USER", this.currentUserId, (res) => {
            this.userAccounts = res.Accounts;
            this.selectedAccount = this.userAccounts.filter(x => { return x.IsDefault == true });
            if (this.userAccounts != undefined && this.userAccounts.length > 0) {
                this.selectAccount(this.selectedAccount);
            }
        }, (err) => { })
    }
    country;
    createShipment(productType) {
        if (this.productTypes) {
            this.data.changeMode("Outbound");
            this.data.changeProductGroup(this.selectProductGroup());
            this.data.changeCountry(this.country.key);
            this.data.changeProductType(productType);
            this.router.navigate(["/dashboard/cashier/receipts/create"]);
        }
        else {
            console.log("no productType")
        }
    }

    ngOnInit() {
        this.getUserAccounts();
        this.utilities.getCountries((res) => {
            this.countries = res;
            var currentCounty = this.countries.filter(x => { return x.value == this.branchCompanyCountryCode })[0];
            this.onCountrySelect(currentCounty);
        }, (err) => { });
        this.calculateRateRequest.Weight = {
            Value: 0.5,
            Unit: this.branchWeightUnit
        }
        this.calculateRateRequest.Account = {
            Reference: 0,
            Number: '',
            Name: ''
        }
    }
}
